import { TransactionStatus } from '../actions/depositFileActions';
import { ConsolidationStatus } from '../actions/consolidationActions';
import { Action, ActionTypes } from '../actions';

export interface ConsolidationKeyInterface {
  pubkey: string;
  validatorindex: number;
  withdrawalcredentials: string;
  status: string;
  transactionStatus: TransactionStatus;
  effectivebalance: number;
  txHash?: string;
  isSource: boolean;
  isTarget: boolean;
  consolidationStatus: ConsolidationStatus;
}

export interface ConsolidationState {
  keys: ConsolidationKeyInterface[];
  isTargetSelected: boolean;
}

export const consolidationReducer = (
  state: ConsolidationState,
  action: Action
): ConsolidationState => {
  if (action.type === ActionTypes.updateValidators) {
    return { ...state, keys: action.payload };
  }

  if (action.type === ActionTypes.updateTargetValidator) {
    let isTargetSelected = false;
    const clonedKeys = state.keys.map(key => {
      const clonedKey = key;
      if (clonedKey.isTarget) {
        clonedKey.isTarget = false;
      }
      if (clonedKey.pubkey === action.payload) {
        isTargetSelected = clonedKey.isTarget;
        return { ...key, isTarget: !clonedKey.isTarget };
      }
      return key;
    });

    return { ...state, keys: clonedKeys, isTargetSelected: !isTargetSelected };
  }

  if (action.type === ActionTypes.updateSourceValidator) {
    const clonedKeys = state.keys.map(key => {
      if (key.pubkey === action.payload)
        return { ...key, isSource: !key.isSource };
      return key;
    });

    return { ...state, keys: clonedKeys };
  }

  if (action.type === ActionTypes.updateTransactionStatus) {
    const clonedKeys = [...state.keys];
    const indexToUpdate = clonedKeys.findIndex(
      key => key.pubkey === action.payload.pubkey
    );
    clonedKeys[indexToUpdate].transactionStatus = action.payload.status;

    if (action.payload.txHash) {
      clonedKeys[indexToUpdate].txHash = action.payload.txHash;
    }

    return { ...state, keys: clonedKeys };
  }

  return state;
};
